module.exports = __webpack_public_path__ + "img/list_pan.5f2b5786.png";